import { navigate } from 'gatsby'
import moment from 'moment'
import React from 'react'
import { RelatedArticleItem } from '../style'

//* components
import Typography from '../../typography'
import WrapperImage from '../../wrapperImage'

//* utils
import DefaultGrid from '../../../../../static/steam-img/no-image-grid.svg'
import { OPTIONS } from '../../../../constants/dateOptions'
import { generateBlogPostSlug, generateSecondaryBlogSlug } from '../../../../utils/blog.utils'
import ImgUtil from '../../../../utils/img.utils'
import formatInlineCode from '../../../../utils/shortTextFormatting'

const getImageInfo = (item: any, type: string) => {
  if (!item) return {}
  const url = item[type]?.image?.file?.url || ''
  const altText = item[type]?.image?.altText || ''
  return { url, altText }
}

export const generateCard = (item: any, index: number, locale: string) => {
  if (!item) return null

  const itemData = {
    heading: item.h1Title || '',
    image: {
      url: getImageInfo(item, 'mainImage').url,
      altText: getImageInfo(item, 'mainImage').altText,
    },
    category: {
      whiteImage: {
        url: getImageInfo(item.category || item.resourceCategory, 'whiteImage').url,
        altText: getImageInfo(item.category || item.resourceCategory, 'whiteImage').altText,
      },
    },
    blogCatory: {
      title: item.blogCategory.overwriteUrlText || item.blogCategory.title,
      useCase: item.blogCategory.useCase || '',
    },
    date: item.date || '',
  }

  let blogCategoryPath = itemData.blogCatory.title
    .toLowerCase()
    .replace(/ *\([^)]*\) */g, '')
    .replace(/\s/g, '-')

  if (blogCategoryPath) {
    if (blogCategoryPath === 'artificial-intelligence') {
      blogCategoryPath = 'ai'
    } else if (blogCategoryPath === 'robotic-process-automation') {
      blogCategoryPath = 'rpa'
    }
  }

  let url = ''
  if (itemData.blogCatory.useCase) {
    //* if useCase is present, the format of the url should be for secondary blogs
    url = generateSecondaryBlogSlug({
      slug: item.slug,
      blogCategoryName: itemData.blogCatory.title,
      useCase: itemData.blogCatory.useCase,
      pageLocale: locale,
    })
  } else {
    //* else the format of the url should be for primary blogs
    url = generateBlogPostSlug({
      slug: item.slug,
      blogCategoryName: itemData.blogCatory.title,
      pageLocale: locale,
    })
  }

  let formattedDate = ''
  if (itemData.date) {
    const date = new Date(itemData.date)
    formattedDate = moment(date).format('MMMM D, YYYY')
    formattedDate = new Date(formattedDate).toLocaleDateString(locale, OPTIONS)
  }

  const imgSrc = itemData.image.url
    ? ImgUtil.getResizedImageUrl(itemData.image.url, 'width=400')
    : DefaultGrid

  return (
    <RelatedArticleItem className="RelatedArticle__Item" key={index}>
      <div onClick={() => navigate(url)}>
        <div className="RelatedArticle__Image-Container">
          {itemData.category.whiteImage.url && (
            <WrapperImage
              className="RelatedArticle__Item-Icon"
              src={ImgUtil.getResizedImageUrl(itemData.category.whiteImage.url, '')}
              alt={itemData.category.whiteImage.altText}
              threshold={650}
            />
          )}

          <WrapperImage
            className="RelatedArticle__BackgroundImg"
            src={imgSrc}
            alt={itemData.image.altText || 'Dotted Grid'}
            threshold={650}
          />
        </div>

        <div className="RelatedArticle__Info-Container">
          <div className="RelatedArticle__Item-Category">
            {blogCategoryPath && ['ai', 'rpa'].includes(blogCategoryPath)
              ? blogCategoryPath.toUpperCase()
              : itemData.blogCatory.title}
          </div>

          <div className="RelatedArticle__Item-Date">{formattedDate}</div>
        </div>

        <div className="RelatedArticle__Text-Container">
          <Typography className="RelatedArticle__Item-Heading" type="header6">
            <a href={url}>{formatInlineCode(itemData.heading)}</a>
          </Typography>
        </div>
      </div>
    </RelatedArticleItem>
  )
}
